import Icon from 'core/components/icons/Icon'
import { useCallback, useState } from 'react'
import { motion } from 'framer-motion'

const tmpAllow = true

interface Props {
  initialRate?: number
  onClick: (rate: number) => void
  disabled?: boolean
}

const RatingStars = ({ onClick, initialRate = 0, disabled }: Props) => {
  const [rating, setRating] = useState(initialRate)
  const [launchTheFirework, setLaunchTheFirework] = useState(0)
  const [vibrateStar, setVibrateStar] = useState(0)
  const [hoveredStar, setHoveredStar] = useState(0)
  const handleMouseEnter = useCallback((index: number) => {
    setHoveredStar(index + 1)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setHoveredStar(rating)
  }, [rating])

  const handleClick = useCallback(
    (rate: number) => {
      if (disabled) return
      const fireworkDelay = 300
      const resetDelay = 500
      setRating(rate)
      setVibrateStar(rate)
      if (rate > 3) {
        setTimeout(() => {
          setLaunchTheFirework(rate)
          setTimeout(() => {
            setVibrateStar(0)
            setLaunchTheFirework(0)
            if (tmpAllow) onClick(rate)
          }, resetDelay)
        }, fireworkDelay)
      } else {
        setTimeout(() => {
          setVibrateStar(0)
          if (tmpAllow) onClick(rate)
        }, fireworkDelay + resetDelay)
      }
    },
    [disabled, onClick]
  )

  return (
    <div>
      <div
        className="flex justify-center gap-5"
        onMouseLeave={handleMouseLeave}
      >
        {Array.from({ length: 5 }, (_, index) => {
          const rate = index + 1
          return (
            <div
              key={index}
              className="relative z-10 w-[30px] h-[30px] cursor-pointer"
              onClick={() => handleClick(rate)}
              onMouseEnter={() => handleMouseEnter(index)}
            >
              {rate > 3 && rate === launchTheFirework && (
                <div className="firework absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0">
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                  <div className="explosion"></div>
                </div>
              )}
              {disabled ? (
                <Icon name="star" noWrapper size={30} color="text-dark" />
              ) : (hoveredStar === 0 && index < rating) ||
                index < hoveredStar ? (
                <motion.div
                  animate={
                    vibrateStar === rate
                      ? {
                          rotate: [
                            0, -30, 0, 30, 0, -30, 0, 30, 0, -30, 0, 30, 0
                          ]
                        }
                      : {}
                  }
                >
                  <Icon
                    name="star"
                    noWrapper
                    size={30}
                    color="text-[#FFC700]"
                  />
                </motion.div>
              ) : (
                <Icon
                  name="star-outline"
                  noWrapper
                  size={30}
                  color="text-[#FFC700]"
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default RatingStars
